import React from "react";
import VIPMediumCard from "../../../../../components/VIPMediumCard";
import { useGetInvoices } from "../../InvoiceCapture/hooks/useGetInvoices";
interface Props {}
export const BackOfficeCard: React.FC<Props> = () => {
  const { data: invoiceData } = useGetInvoices();

  return (
    <>
      <VIPMediumCard
        title={"Back Office"}
        showPlustButton={false}
        cardRowName1={"Unassigned Invoices"}
        cardRowCount1={
          invoiceData?.data
            ?.filter((c) => c.invoiceNumber === null)
            .map((x) => ({ ...x })).length
        }
        cardRowName2={"Pending Review"}
        cardRowCount2={
          invoiceData?.data
            ?.filter((c) => c.status === "For Review")
            .map((x) => ({ ...x })).length
        }
        cardRowName3={"All Unpaid Invoices"}
        cardRowCount3={
          invoiceData?.data
            ?.map((data) => ({ ...data }))
            .filter((x) => x.status === "Approved").length
        }
        className={"underline"}
      />
    </>
  );
};
